/**
 * Algolia Events Filter Handler
 * Handles M3 select component filtering for Algolia events by retail center
 * Integrates with Load More pagination system
 */

document.addEventListener('DOMContentLoaded', function() {
    const filterSelect = document.getElementById('algolia-center-select');
    const eventsContainer = document.querySelector('.event-wrapper .event-list');
    const eventCounter = document.querySelector('.event-counter');
    const loadMoreButton = document.getElementById('load-more-events');

    if (!filterSelect || !eventsContainer) {
        return; // Exit if elements don't exist on page
    }

    // Handle M3 select change event
    filterSelect.addEventListener('change', function(e) {
        const selectedCenter = e.target.value;

        // Show loading state
        eventsContainer.innerHTML = '<p class="loading">Loading events...</p>';

        // Hide load more button during filter
        if (loadMoreButton) {
            loadMoreButton.style.display = 'none';
        }

        // Build AJAX URL
        const params = new URLSearchParams({
            action: 'filter_algolia_events',
            center: selectedCenter
        });

        const ajaxUrl = `${window.location.origin}/wp-admin/admin-ajax.php?${params.toString()}`;

        // Fetch filtered events
        fetch(ajaxUrl)
            .then(response => response.json())
            .then(data => {
                if (data.success) {
                    eventsContainer.innerHTML = data.data;

                    // Reset load more pagination if it exists
                    if (window.eventLoadMore) {
                        window.eventLoadMore.reset();

                        // Update event list data attributes
                        eventsContainer.dataset.currentPage = '1';
                        eventsContainer.dataset.retailCenter = selectedCenter;
                    }

                    // Update event counter if present
                    const newEventCount = eventsContainer.querySelectorAll('.event-item').length;
                    if (eventCounter) {
                        const currentCountEl = eventCounter.querySelector('.current-count');
                        const totalCountEl = eventCounter.querySelector('.total-count');
                        if (currentCountEl && totalCountEl) {
                            currentCountEl.textContent = newEventCount;
                            // Total count would need to come from backend - placeholder for now
                        }
                    }

                    // Show/hide load more button based on result count
                    // This assumes backend returns data attribute for pagination
                    const maxPages = parseInt(eventsContainer.dataset.maxPages) || 1;
                    if (loadMoreButton && maxPages > 1) {
                        loadMoreButton.style.display = '';
                    }

                    // Trigger GTM tracking for filter selection
                    if (window.dataLayer) {
                        window.dataLayer.push({
                            'event': 'holiday custom event',
                            'name': 'filter_selection',
                            'filter': selectedCenter || 'All Centers'
                        });
                    }
                } else {
                    eventsContainer.innerHTML = '<p class="error">Error loading events. Please try again.</p>';
                }
            })
            .catch(error => {
                console.error('Filter error:', error);
                eventsContainer.innerHTML = '<p class="error">Error loading events. Please try again.</p>';
            });
    });
});
